// Lightweight code formatting utility using Prettier standalone
// Dynamically imports Prettier and the necessary language plugins when used

export async function formatCode(language, code) {
  if (!code || typeof code !== 'string') return code;

  const prettier = (await import('prettier/standalone')).default;

  // Load only the plugins we need
  const [babel, html, postcss] = await Promise.all([
    import('prettier/plugins/babel'),
    import('prettier/plugins/html'),
    import('prettier/plugins/postcss'),
  ]);

  const lang = (language || '').toLowerCase();
  /** @type {import('prettier').Options} */
  const baseOptions = {
    printWidth: 100,
    tabWidth: 2,
    singleQuote: true,
    trailingComma: 'es5',
    semi: true,
    bracketSpacing: true,
    bracketSameLine: false,
    plugins: [babel, html, postcss],
  };

  let parser = 'babel';
  if (lang === 'html' || lang === 'markup') parser = 'html';
  else if (lang === 'css' || lang === 'scss' || lang === 'less') parser = 'css';
  else if (lang === 'javascript' || lang === 'js' || lang === 'jsx') parser = 'babel';

  try {
    return await prettier.format(code, { ...baseOptions, parser });
  } catch (e) {
    // If formatting fails, return original code
    console.warn('Prettier formatting failed:', e);
    return code;
  }
}

export default formatCode;
